import { render } from "./RegisterViaOTP.vue?vue&type=template&id=5fb249c9"
import script from "./RegisterViaOTP.vue?vue&type=script&lang=js"
export * from "./RegisterViaOTP.vue?vue&type=script&lang=js"

import "./RegisterViaOTP.vue?vue&type=style&index=0&id=5fb249c9&lang=css"

import exportComponent from "/var/www/zaytoon-frontend-base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__